import {Component, OnInit} from '@angular/core';
import {BlocksComponent} from '@blocks/blocks.component';

@Component({
  selector: 'pl-pdf-part-child',
  templateUrl: '../blocks.component.html',
  styleUrls: [
    '../blocks.component.scss',
    './pdf-part-child.component.scss'
  ]
})
export class PdfPartChildComponent extends BlocksComponent implements OnInit {
  ngOnInit() {
    super.ngOnInit();
  }
}
